import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadApprovalData,
  loadApprovalFeatures,
  LomavisPostApprovalStateInitialState,
  setApprovalUI
} from '../../../../redux/slices/LomavisPostApproval/lomavisPostApproval';
import { useTranslate } from '@tolgee/react';
import {
  STEP_MODE_MULTI_STEP,
  STEP_MODE_SINGLE_STEP
} from '../../../../redux/slices/LomavisPostApproval/constants';
import lomavisCreator from '../../../../pages/lomavisCreator';

const PostApprovalSection = () => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const {
    ui: { showPostApprovalCreatorModal }
  } = useSelector((state: any) => state.lomavisPostApproval);

  const { approval_process, lomavisCreatorConfig } = useSelector(
    (state: any) => state.lomavisCreator
  );

  const PostApprovalButtonStepIndicator = ({ users, groups }) => {
    let icon = <i className="fa fa-duotone fa-user"></i>;
    let number = users?.length;

    if (groups) {
      icon = <i className="fa-duotone fa-solid fa-user-group"></i>;
      number = 1; // Corrected variable name
    }

    return (
      <span className="me-1 d-flex align-items-center gap-1">
        <span className={'badge badge-warning'}> {number}</span>
        <span className="">{icon}</span>
      </span>
    );
  };

  return (
    <button
      className="btn btn-secondary me-2 btn-sm d-flex align-items-center w-auto text-nowrap"
      style={{
        minWidth: 'max-content',
        whiteSpace: 'nowrap',
        display: 'inline-flex'
      }}
      onClick={() => {
        dispatch(
          loadApprovalFeatures({
            approvalProcessMultistep:
              lomavisCreatorConfig?.features?.approval_process_multistep,
            approvalProcessSaveAsApprovedPost:
              lomavisCreatorConfig?.features
                ?.approval_process_save_as_approved_post,
            approvalProcessGroups:
              lomavisCreatorConfig?.features?.approval_process_groups
          })
        );
        if (approval_process) {
          dispatch(loadApprovalData(approval_process));
        }

        dispatch(
          setApprovalUI({
            key: 'showPostApprovalCreatorModal',
            value: !showPostApprovalCreatorModal
          })
        );
      }}
    >
      <i className="fa-duotone fa-tasks me-1"></i>
      {approval_process === null ? (
        <span>{t('lomavisCreator.buttonsBar.postApproval')}</span>
      ) : approval_process?.step_mode === STEP_MODE_SINGLE_STEP ? (
        <span className="d-inline-flex align-items-center gap-1">
          <span className="d-none d-lg-inline">
            {t('lomavisCreator.buttonsBar.Approval')}
          </span>
          <span className="d-inline d-lg-none">
            {t('lomavisCreator.buttonsBar.ApprovalShort')}
          </span>
          {PostApprovalButtonStepIndicator({
            users: approval_process?.approval_step_1_users,
            groups: approval_process?.approval_step_1_group
          })}
        </span>
      ) : approval_process?.step_mode === STEP_MODE_MULTI_STEP ? (
        <span className="d-inline-flex align-items-center gap-1">
          <span className="d-none d-lg-inline">
            {t('lomavisCreator.buttonsBar.Approval')}
          </span>
          <span className="d-inline d-lg-none">
            {t('lomavisCreator.buttonsBar.ApprovalShort')}
          </span>
          {PostApprovalButtonStepIndicator({
            users: approval_process?.approval_step_1_users,
            groups: approval_process?.approval_step_1_group
          })}
          {PostApprovalButtonStepIndicator({
            users: approval_process?.approval_step_2_users,
            groups: approval_process?.approval_step_2_group
          })}
        </span>
      ) : (
        <span>{t('lomavisCreator.buttonsBar.postApproval')}</span>
      )}
    </button>
  );
};

export default PostApprovalSection;
